export const EXTERNAL_LINKS = {
  unithroid: {
    INFO: 'https://unithroid.com/help-patients-save?utm_source=%esid!&utm_medium=patientcompass&utm_campaign=%ebuy!&utm_content=%ecid!&utm_term=%epid!',
    PRESCRIBLING_INFO:
      'https://dailymed.nlm.nih.gov/dailymed/fda/fdaDrugXsl.cfm?setid=07562e72-7eaa-4ce6-94f0-e08814787e50&type=display',
    TERMS_CONDITIONS:
      'https://unithroid.com/#full-terms-and-conditions?utm_source=%esid!&utm_medium=patientcompass&utm_campaign=%ebuy!&utm_content=%ecid!&utm_term=%epid!'
  },
  xdemvy: {
    INFO: 'https://xdemvy.com/?utm_source=single_care&utm_medium=website&utm_campaign=xdemvy_US--2300578_patient_compass#Save',
    PRESCRIBLING_INFO:
      'https://protect-us.mimecast.com/s/0lOQCYENXof3l3gxfMxciJ?domain=urldefense.proofpoint.com',
    TERMS_CONDITIONS:
      'https://protect-us.mimecast.com/s/2DjFCW6XBkUjqjxBuK7CBn?domain=urldefense.proofpoint.com'
  }
};

export const PATIENT_COMPASS_EVENTS = {
  TNC_EVENT: 'patientCompassTnc',
  PRESCRIBE_INFO_EVENT: 'patientCompassPrescribeInfo',
  CTA_EVENT: 'patientCompassCta'
};

export const ADS_PLACEMENT = {
  DRUG_PAGE: 'drug-page',
  WHAT_IS_PAGE: 'what-is-page',
  DOSAGE_PAGE: 'dosage-page',
  SIDE_EFFECTS_PAGE: 'side-effects-page',
  BLOG_PAGE: 'blog-page',
  CONDITION_PAGE: 'conditions-page'
};
